import { NavLink } from 'react-router-dom';
import { ChatTeardropDots, Envelope } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';

export function CommunicationsTabBar() {
  return (
    <div className="flex items-center border-b border-border/60 bg-card px-1">
      <NavLink
        to="/barrister/communications"
        end
        className={({ isActive }) =>
          cn(
            'flex h-9 items-center gap-2 border-b-2 px-4 text-xs font-medium transition-colors',
            isActive
              ? 'border-brand-600 text-brand-700 dark:text-brand-300'
              : 'border-transparent text-muted-foreground hover:text-foreground',
          )
        }
      >
        <ChatTeardropDots size={13} />
        Messages
      </NavLink>
      <NavLink
        to="/barrister/inbox"
        className={({ isActive }) =>
          cn(
            'flex h-9 items-center gap-2 border-b-2 px-4 text-xs font-medium transition-colors',
            isActive
              ? 'border-brand-600 text-brand-700 dark:text-brand-300'
              : 'border-transparent text-muted-foreground hover:text-foreground',
          )
        }
      >
        <Envelope size={13} />
        Email Inbox
      </NavLink>
    </div>
  );
}
